export enum ThemeDataKeys {
  theme = 'theme',
  name = 'name'
}
